import { defineStore } from 'pinia';
import { useModalsStore } from './modals';
import { setFavoriteStore } from '@/composition/useLocalStore';
import { maxAge } from '@/common/const';

const cookieKey = 'favorite';
const cookieCountKey = 'favorite-count';

interface productsCount {
  [key: string]: number;
}

export const useFavoriteStore = defineStore('favorite', () => {
  const ids = ref<number[]>([]);
  const countInCategory = ref({});
  const modalsStore = useModalsStore();
  interface favoriteItem {
    id: number;
    catId: number;
    deleteCard: boolean;
  }

  function setFavoriteState(fav: { ids: number[]; count: productsCount }) {
    ids.value = [...fav.ids];
    countInCategory.value = fav.count;
  }

  function getFavoriteEnvironment() {
    const cookie = useCookie(cookieKey, {
      path: '/',
      maxAge,
    });

    const _ids = cookie.value
      ? cookie.value
          .toString()
          .split(',')
          .map((e) => +e)
      : [];
    const cookieCount = useCookie(cookieCountKey, {
      path: '/',
      maxAge,
    });

    const count = cookieCount.value
      ? Object.fromEntries(
          cookieCount.value
            .toString()
            .split(',')
            .map((e) => {
              const val = e.split('-');
              return [val[0], +val[1]];
            })
        )
      : {};
    if (_ids.length) setFavoriteState({ ids: _ids, count });
  }

  function toggleFavorite({ id, catId, deleteCard }: favoriteItem) {
    let newIds: number[] = ids.value;
    const count: productsCount = { ...countInCategory.value };
    let deleted = !!deleteCard;
    if (newIds.includes(id)) {
      newIds = newIds.filter((fId) => fId !== id);
      deleted = true;
      if (--count[catId] < 1) delete count[catId];
    } else {
      deleted = false;
      if (newIds.length >= 300) {
        modalsStore.setData({
          name: 'limit',
          data: {
            type: 'favorite',
          },
        });
        return;
      } else {
        newIds = [...newIds, id];
        count[catId] = count[catId] ? count[catId] + 1 : 1;
      }
    }
    const _cookieCount = useCookie(cookieCountKey, {
      path: '/',
      maxAge,
    });

    _cookieCount.value = Object.entries(count)
      .map((el) => el.join('-'))
      .join(',');

    const _cookieKey = useCookie(cookieKey, {
      path: '/',
      maxAge,
    });
    _cookieKey.value = newIds.join(',');

    setFavoriteState({ ids: newIds, count });

    setFavoriteStore({ ids: newIds, count });

    const isNotification = modalsStore.get.notification;
    const payload = {
      name: 'notification',
      data: {
        type: 'favorite',
        categoryCount: count[catId],
        deleteCard: deleted,
        id,
        catId,
        date: Date.now(),
      },
    };

    isNotification ? modalsStore.update(payload) : modalsStore.setData(payload);
    return newIds;
  }

  function clearFavorite() {
    const _cookieCount = useCookie(cookieCountKey, {
      path: '/',
      maxAge,
    });
    _cookieCount.value = null;
    const _cookieKey = useCookie(cookieKey, {
      path: '/',
      maxAge,
    });
    _cookieKey.value = null;

    setFavoriteState({ ids: [], count: {} });
    setFavoriteStore({ ids: [], count: {} });
  }

  function externalToggleFavorite(id: string, catId: string, key: string) {
    if (id && catId && key === '8tjFVGPSXybonKgALDh2RkxmHEzf4WTQwvN0') {
      toggleFavorite({ id: Number(id), catId: Number(id), deleteCard: false });
    }
  }

  return {
    ids,
    toggleFavorite,
    countInCategory,
    getFavoriteEnvironment,
    clearFavorite,
    setFavoriteState,
    externalToggleFavorite,
  };
});
